'use strict';


var util = require('./util');

var randoms = {};

'boolean string number dx array datetime form network names article color'.split(' ')
  .forEach(function (name) {
    var module = require('./random/' + name);
    for (var methodName in module) {
      if (util.hasKey(module, methodName)) {
        randoms[methodName] = module[methodName];
      }
    }
  });

module.exports = randoms;



//////////////////
// WEBPACK FOOTER
// ./node_modules/generate-random-data/lib/index.js
// module id = 758
// module chunks = 0